import React, { Component } from 'react';
import './../../css/temp_right_content.css';
import DashboardMainContent from './cryptos/dashboard_main_content.js';
import AiDAO from './cryptos/aidao.js';
import Ethereum from './cryptos/ethereum.js';
import Golem from './cryptos/golem.js';
import Cobinhood from './cryptos/cobinhood.js';
import CyberMiles from './cryptos/cybermiles.js';
import Essentia from './cryptos/essentia.js';
import WandX from './cryptos/wandx.js';
import XYO from './cryptos/xyo.js';
import FuzeX from './cryptos/fuzex.js';
import NOBAR from './cryptos/nbr.js';
import Orbs from './cryptos/orbs.js';
import BitRewards from './cryptos/bitrewards.js';
import SingularityNet from './cryptos/singularitynet.js';
import Incodium from './cryptos/incodium.js';
import Autonio from './cryptos/autonio.js';
import Credits from './cryptos/credits.js';
import NCash from './cryptos/ncash.js';
import KickToken from './cryptos/kicktoken.js';
import Stacs from './cryptos/stacs.js';
import Dicet from './cryptos/dice.js';
import MoneyNet from './cryptos/moneynet.js';
import Account from './account.js';
import Notification from './notification.js';
import SecurityCenter from './securitycenter.js';
import History from './history.js';
import SwapCenter from './swapcenter.js';
import TokenPage from './tokenpage.js';

export default class RightContent extends Component {

  render() {

    var data = this.props.data;
    var content;
    if (this.props.name === "account") {
      content = <Account data={data.account}/>;
    } else if (this.props.name === "security") {
      content = <SecurityCenter data={data}/>;
    } else if (this.props.name === "history") {
      content = <History data={data.history}/>;
    } else if (this.props.name === "notification") {
      content = <Notification data={data.notification}/>;
    } else if (this.props.name === "swapcenter") {
      content = <SwapCenter data={data}/>;
    } else if (this.props.name === "tokenpage") {
      content = <TokenPage data={data}/>;
    } else if (this.props.name === "aidao") {
      content = <AiDAO data={data}/>;
    } else if (this.props.name === "ethereum") {
      content = <Ethereum data={data}/>;
    } else if (this.props.name === "golem") {
      content = <Golem data={data}/>;
    } else if (this.props.name === "cobinhood") {
      content = <Cobinhood data={data}/>;
    } else if (this.props.name === "wandx") {
      content = <WandX data={data}/>;
    } else if (this.props.name === "xyo") {
      content = <XYO data={data}/>;
    } else if (this.props.name === "fuzex") {
      content = <FuzeX data={data}/>;
    } else if (this.props.name === "nbr") {
      content = <NOBAR data={data}/>;
    } else if (this.props.name === "bitrewards") {
      content = <BitRewards data={data}/>;
    } else if (this.props.name === "ncash") {
      content = <NCash data={data}/>;
    } else if (this.props.name === "essentia") {
      content = <Essentia data={data}/>;
    } else if (this.props.name === "singularitynet") {
      content = <SingularityNet data={data}/>;
    } else if (this.props.name === "incodium") {
      content = <Incodium data={data}/>;
    } else if (this.props.name === "autonio") {
      content = <Autonio data={data}/>;
    } else if (this.props.name === "dicet") {
      content = <Dicet data={data}/>;
    } else if (this.props.name === "credits") {
      content = <Credits data={data}/>;
    } else if (this.props.name === "moneynet") {
      content = <MoneyNet data={data}/>;
    } else if (this.props.name === "stacs") {
      content = <Stacs data={data}/>;
    } else if (this.props.name === "orbs") {
      content = <Orbs data={data}/>;
    } else if (this.props.name === "kick") {
      content = <KickToken data={data}/>;
    } else {
      content = <DashboardMainContent data={data}/>;
    }

    return (

            <div class="content-page">
              <div class="content">
                  <div class="container">
                    {content}
                  </div>
              </div>

            </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/rightcontent.js